import {
  PayloadAction,
  createEntityAdapter,
  createSlice,
} from '@reduxjs/toolkit';
import { LoadingStates } from '@tdp/common/constants';
import { IPeoplePicker } from './IPeoplePickerReader';


interface IPeoplePickerState {
  users: IPeoplePicker[];
}

const initialState: IPeoplePickerState = {
  users: []
}

export const peoplePickerSlice = createSlice({
  name: "peoplePicker",
  initialState,
  reducers: {
    setUsers: (state, action: PayloadAction<IPeoplePicker[]>) => {
      state.users = action.payload;
    }
  },
  selectors: {
    users: (s) => s.users,
  }
});